export const ColumnSize = {
  WIDTH_1: 100,
  WIDTH_2: 120,
  WIDTH_3: 130,
  WIDTH_4: 140,
  WIDTH_5: 160,
  WIDTH_6: 180,
  WIDTH_7: 200,
  WIDTH_8: 220,
  WIDTH_0: 90,
};
export const TimeArray = () => {
  const array: { id: number; value: string }[] = [];
  for (let i = 0; i < 24; i += 1) {
    array.push({
      id: i,
      value:
        (i + 1).toString().length === 1
          ? `0${(i + 1).toString()}:00`
          : `${(i + 1).toString()}:00`,
    });
  }
  return array;
};
export const NumberArray = (value: number) => {
  const array: { id: number; value: string }[] = [];
  for (let i = 0; i < value; i += 1) {
    array.push({ id: i, value: (i + 1).toString() });
  }
  return array;
};
export const SERVICE_KEY = "TIREPICK_REPAIR_SHOP_WEB";
export const IMAGE_URL_SERVER = "http://tirepick-static.slogup.com/";
export const ServiceArray = [
  { id: 0, name: "0", value: "전체" },
  { id: 1, name: "1", value: "서비스1" },
  { id: 2, name: "2", value: "서비스2" },
  { id: 3, name: "3", value: "서비스3" },
  { id: 4, name: "4", value: "서비스4" },
];
export const PlatformArray = [
  { id: 1, name: "android", value: "android" },
  { id: 2, name: "ios", value: "ios" },
];
export const PlatformFilterArray = [
  { id: 1, name: "1", value: "전체" },
  { id: 2, name: "2", value: "ios" },
  { id: 3, name: "3", value: "android" },
];
export const ModalServiceArray = [
  { id: 1, name: "1", value: "서비스1" },
  { id: 2, name: "2", value: "서비스2" },
  { id: 3, name: "3", value: "서비스3" },
  { id: 4, name: "4", value: "서비스4" },
];
export const AnswerStatusArray = [
  { id: 1, name: "all", value: "전체" },
  { id: 2, name: "recieved", value: "접수중" },
  { id: 3, name: "pending", value: "답변중" },
  { id: 4, name: "replied", value: "답변완료" },
];
export const RadioArray = [
  { id: 1, value: "전체" },
  { id: 2, value: "노출" },
  { id: 3, value: "미노출" },
];

export const ModalRadioArray = [
  { id: 1, value: "노출" },
  { id: 2, value: "미노출" },
];

export const FaqQuestionArray = [
  { id: 1, name: "1", value: "전체" },
  { id: 2, name: "2", value: "로그인" },
  { id: 3, name: "3", value: "회원가입" },
];

export const ModalFaqQuestionArray = [
  { id: 1, name: "login", value: "로그인" },
  { id: 2, name: "signUp", value: "회원가입" },
];

export const strings = {
  SUCCESS_MODIFY: "성공적으로 수정되었습니다.",
  SUCCESS_REGISTER: "성공적으로 등록되었습니다.",
  SUCCESS_REMOVE: "성공적으로 삭제되었습니다.",
};

export const MIN_MORNITOR_WIDTH = "540px";

export const MAX_WIDTH = "320px";

export const ALERT_MESSAGE = {
  PHONE_SEND: "문자가 전송되었습니다.인증 코드를 확인해주세요.",
  PHONE_SEND_FAILURE: "문자 전송에 실패하였습니다. 다시 시도 해주세요.",
  NO_PHONE_AUTH: "휴대폰 번호 인증이 필요합니다",
  WRONG_AUTH: "인증번호가 일치하지 않습니다.확인후 다시 진행해주세요",
  NO_DUPLIACTE_CHECK: "아이디 중복확인이 필요합니다",
  DUPLICATED_ID: "현재 사용중인 아이디입니다.",
  INVALID_REPASS: "비밀번호 확인이 일치하지 않습니다",
  NEED_NAME: "성함을 입력해주세요",
  WRONG_PHONE: "올바른 휴대폰 번호를 입력해주세요",
  WRONG_EMAIL: "올바른 이메일 주소를 입력해주세요",
  WRONG_TEL: "올바른 전화번호를 입력해주세요",
  NEED_NUMBER: "올바른 번호를 입력해주세요.",
  WRONG_BUSI_NUMBER: "올바른 사업자등록번호를 입력해주세요",
  EXCEED_AUTH_TIME: "인증시간이 초과되었습니다",
  EXCEED_FILE_SIZE: "파일 용량이 초과되었습니다.최대 1MB까지 가능",
  INVALID_FILE_FORMAT: "파일 형식을 다시 확인해주세요.JPG,PNG,GIF 형식만 가능",
  NULL_REQUIRED: "필수 값입니다.",
  NOT_VERIFIED_PHONE: "등록된 아이디와 휴대폰번호가 일치하지 않습니다",
};
export const SUCCESS_MESSAGE = {
  VALID_REPASS: "비밀번호가 일치합니다.",
  VALID_ID: "사용가능한 아이디입니다.",
  NO_DUPLIACTED_ID: "사용가능한 아이디입니다.",
};
export const PLACEHOLDER = {
  EMAIL: "이메일을 입력해주세요",
  ID: "아이디를 입력해주세요",
  PASS: "비밀번호를 입력해주세요",
  AUTH_NAME: "권한 명칭을 입력해주세요",
  AUTH_DESC: "권한 설명을 입력해주세요",
  NAME: "이름을 입력해주세요",
  TITLE: "제목을 입력해주세요",
  BODY: "내용을 입력해주세요",
  PHONE: "휴대폰번호를 입력해주세요",
  USER: "사용자를 입력해주세요",
  NUMBER: "숫자만 입력해주세요",
  REPASS: "비밀번호를 한 번 더 입력해주세요",
};
export const LABEL_TEXT = {
  AID: "아이디",
  PASS: "비밀번호",
  PHONE: "휴대폰 번호",
  EMAIL: "이메일 주소",
  DISPLAY_NAME: "상호명",
  MANAGER_NAME: "담당자 성함",
  REPAIRSHOP_TEL: "매장 대표번호",
  REAL_NAME: "사업자 등록증 상호명",
  ADDRESS: "매장 주소",
  BUSINESS_MEDIA_ID: "사업자 등록증",
  MEDIA_IDS: "매장 전경사진",

  OPEN_DAY: "영업일",
  IS_HOLIDAY_OPEN: "공휴일 영업여부",
  WORKDAY_OPEN: "평일 영업시간",
  SAT_OPEN: "토요일 영업시간",
  SUN_OPEN: "일요일 영업시간",
  HOLIDAY_OPEN: "공휴일 영업시간",

  LIFT_COUNT: "보유 리프트(개)",
  EMPLOYEE_COUNT: "보유 정비인력(명)",
  FOREIGN_WHEEL_ALIGNMENT: "휠 얼라인먼트(수입차)",
  DOMESTIC_WHEEL_ALIGNMENT: "휠 얼라인먼트(국산차)",
  FLAT_TIRE: "런플랫 타이어",
  LIGHT_REPAIR: "경정비",
  FOREIGN_REPAIR: "수입차정비",
  REST_ROOM: "고객 대기실 보유여부",
  TWENTY_TIRE: "20인치 타이어 장착",

  ADDITIONAL: "추가사항",
  ONE_SENTENCE: "메징 한마디",
};
export const BUSINESS_MEDIA_ID_EXPLAIN =
  "첨부파일은 최대 3MB, 1개 까지 사진파일 형식만 가능합니다. (JPG, PNG, GIF)";
export const IMAGE_UPLOAD_EXPLAIN =
  "첨부파일은 최대 3MB, 1개 까지 사진파일 형식만 가능합니다. (JPG, PNG, GIF)";
export const MEDIA_ID_EXPLAIN =
  "첨부파일은 최대 3MB 사진파일 형식만 가능합니다. (JPG, PNG, GIF)";
